import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/log-in.jpeg")